import axios from "axios";
import authHeader from "./auth-header";
import { toast } from "react-toastify";

export const createPricelistDetail = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/pricelistdetail`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const getBillingRate = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/pricelistdetail/billing-rate`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      // Don't show toast error here as we'll handle it in the component
      throw err;
    });
};
